<header class="header">
  <div class="section">
    <button type="button" class="logo-button" (click)="goHome()">
      <mat-icon svgIcon="logo" />
    </button>
  </div>
  <div class="section">
    @if (auth.isAuthenticated()) {
      <app-user-photo-initials [fullName]="userName() || ''" />
      <app-general-icon-button
        buttonStyle="inline"
        buttonIcon="logout"
        [buttonTooltip]="'app.general.logout'"
        [buttonTooltipPosition]="TooltipPosition.BELOW"
        (buttonClicked)="logout()"
      />
    }
  </div>
</header>
